"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionHeader = void 0;
const React = __importStar(require("react"));
const AccordionHeader_styled_1 = require("./AccordionHeader.styled");
const AccordionHeader = ({ children, icon, open, chevronWidth, onClick }) => {
    return React.createElement(AccordionHeader_styled_1.StyledAccordionHeader, { onClick: onClick },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            icon && icon(),
            React.createElement("div", null, children)),
        React.createElement(AccordionHeader_styled_1.StyledAccordionChevron, { width: chevronWidth !== null && chevronWidth !== void 0 ? chevronWidth : 40, open: open !== null && open !== void 0 ? open : false }));
};
exports.AccordionHeader = AccordionHeader;
//# sourceMappingURL=AccordionHeader.js.map